import { provideLazy } from '@/config/injections.ts';
import type { Config } from '@/config/ConfigSchema.ts';
import { CONFIG } from '@/config/ConfigKeys.ts';

export const provideConfig = (config: Config) => {
  provideLazy(CONFIG, () => config);
};
